import React, { useEffect, useState, useRef } from 'react';
import * as Utils from '../../commons/utils/Utils';
import backendStrings from '../../lang/backendStrings.js';
import Select from 'react-select';
import Security from '../../commons/security/Security.js';
import { FormattedMessage, useIntl } from 'react-intl';
import {
	Grid,
	Typography,
	TextField,
	Button,
	IconButton
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';

const ModalAccion = ({ reporte, onClose, onConfirm, onDesestimar, accion, loading}) => {
	const intl = useIntl()
	const [comentario, setComentario] = useState('');

	useEffect(() => {
		if(accion) {
			setComentario('');
		}
	}, [accion]);

	if (!reporte) return null;

	return (
		<>
			{/* Header */}
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Grid container alignItems="center" spacing={1}>
						<Grid item>
							{accion === 'confirmar' ? (
								<CheckCircleIcon style={{ color: '#28a745' }} />
							) : (
								<CancelIcon style={{ color: '#dc3545' }} />
							)}
						</Grid>
						<Grid item>
							<Typography variant="h6">
								{accion === 'confirmar' ? (
									<FormattedMessage id="safeFeedback_modalAccion.render.Confirmar_Queja" defaultMessage="Confirmar Queja" />
								) : (
									<FormattedMessage id="safeFeedback_modalAccion.render.Desestimar_Queja" defaultMessage="Desestimar Queja" />
								)}
							</Typography>
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</Grid>
			</Grid>

			{/* Body */}
			<Grid container spacing={2} style={{ marginTop: 16 }}>
				<Grid item xs={6}>
					<Typography><FormattedMessage id="safeFeedback_modalAccion.render.Queja" defaultMessage="Queja" /></Typography>
					<Typography><b>#{reporte.id}</b></Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalAccion.render.Conductor" defaultMessage="Conductor" /></Typography>
					<Typography>
						<b>{reporte.conductor || 'No asignado'}</b>
					</Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalAccion.render.Fecha_y_Hora" defaultMessage="Fecha y Hora" /></Typography>
					<Typography><b>{reporte.fecha}</b></Typography>
				</Grid>

				<Grid item xs={6}>
					<Typography><FormattedMessage id="safeFeedback_modalAccion.render.Vehículo" defaultMessage="Vehículo" /></Typography>
					<Typography><b>{reporte.dominio}</b></Typography>
					<br/>
					<Typography><FormattedMessage id="safeFeedback_modalAccion.render.Tipo" defaultMessage="Tipo" /></Typography>
					<Typography ><b>{reporte.tipo_relato}</b></Typography>
				</Grid>
			</Grid>

			<br/>
			<Typography
				style={{ marginTop: 16 }}
			>
				<FormattedMessage id="safeFeedback_modalAccion.render.Descripción" defaultMessage="Descripción" />
			</Typography>
			<Typography>
				<b>{reporte.descripcion}</b>
			</Typography>

			<br/>
			<Typography
				style={{ marginTop: 16 }}
			>
				<FormattedMessage id="safeFeedback_modalAccion.render.Comentarios" defaultMessage="Comentarios" />{accion === 'desestimar' ? '*' : ''}
			</Typography>
			<TextField
				placeholder={accion === 'confirmar' ?
					intl.formatMessage({id: "safeFeedback_modalAccion.render.Comentarios_adicionales_opcional", defaultMessage: "Comentarios adicionales (opcional)..."}) :
					intl.formatMessage({id: "safeFeedback_modalAccion.render.Explique_razon_desestimacion", defaultMessage: "Explique la razón de la desestimación..."})
				}
				fullWidth
				multiline
				minRows={3}
				variant="outlined"
				value={comentario}
				inputProps={{ maxLength: 250 }}
				onChange={(e) => setComentario(e.target.value)}
			/>

			<Grid
				container
				justifyContent="flex-end"
				spacing={1}
				style={{ marginTop: 24 }}
			>
				<Grid item>
					<Button onClick={onClose}>
						<FormattedMessage id="safeFeedback_modalAccion.render.Cancelar" defaultMessage="Cancelar" />
					</Button>
				</Grid>
				<Grid item>
					{
						accion === 'confirmar' ?
							<Button
								className="btn btn-primary"
								onClick={() => onConfirm(comentario)}
								disabled={loading}
							>
								<FormattedMessage id="safeFeedback_modalAccion.render.Confirmar" defaultMessage="Confirmar" />
							</Button>
						:
							<Button
								className="btn btn-danger"
								onClick={() => onDesestimar(comentario)}
								disabled={comentario === '' || loading}
							>
								<FormattedMessage id="safeFeedback_modalAccion.render.Desestimar" defaultMessage="Desestimar" />
							</Button>
					}
				</Grid>
			</Grid>
		</>
	);
};

export default ModalAccion;
